//@flow

import React from 'react'
import { connect } from 'react-redux'

import {
  selectIsIconPickerOpen,
  selectIsIconCreationOpen,
  closeIconCreation,
  selectIsSnippetInfoOpen,
  selectIsSnippetCreationOpen,
  openSnippetCreation,
  closeSnippetInfo,
} from '../../stores/pollBuilderIconPicker'

import { clearExpertOpinionSelection } from '../../stores/pollBuilderSelectedExpertOpinion'

import type { RootState } from '../../types'

import { Modal } from '../Modal'
import IconPicker from './IconPicker'
import IconCreator from './IconCreator'
import SnippetInfo from './SnippetInfo'

const Snippets = ({
  isSnippetInfoOpen,
  isSnippetCreationOpen,
  isIconPickerOpen,
  isIconCreationOpen,
  closeIconCreation,
  openSnippetCreation,
  closeSnippetInfo,
  clearExpertOpinionSelection,
}) => {
  const CROP_WIDTH = 200
  const CROP_HEIGHT = 200
  const PREVIEW_RADIUS = 62
  const leftModalWidth = isSnippetInfoOpen ? `w-49` : `w100`
  const rightModalWidth =
    isIconPickerOpen || isIconCreationOpen ? `w-49` : `w100`

  const showIconCreationOrPicker = isIconPickerOpen || isIconCreationOpen
  const showSnippetInfo = isSnippetInfoOpen

  const renderIconCreation = () => {
    const handleCancel = () => {
      closeIconCreation()
      openSnippetCreation()
    }
    if (!isIconCreationOpen) {
      return null
    }

    return (
      <IconCreator
        cropWidth={CROP_WIDTH}
        cropHeight={CROP_HEIGHT}
        onClose={closeIconCreation}
        onCancel={handleCancel}
      />
    )
  }

  const renderIconPicker = () => {
    if (!isIconPickerOpen) {
      return null
    }

    return <IconPicker />
  }

  const renderSnippetInfo = () => {
    const handleClose = () => {
      clearExpertOpinionSelection()
      closeSnippetInfo()
    }

    return (
      <SnippetInfo
        previewRadius={PREVIEW_RADIUS}
        onClose={handleClose}
        onDelete={handleClose}
      />
    )
  }

  if (isSnippetCreationOpen) {
    return (
      <Modal>
        <div className="w-100 flex justify-center">
          {showIconCreationOrPicker && (
            <div className={`${leftModalWidth} mr2`}>
              {renderIconCreation()}
              {renderIconPicker()}
            </div>
          )}

          {showSnippetInfo && (
            <div className={`${rightModalWidth}`}>{renderSnippetInfo()}</div>
          )}
        </div>
      </Modal>
    )
  } else {
    return null
  }
}

const mapStateToProps = (state: RootState) => {
  return {
    isSnippetInfoOpen: selectIsSnippetInfoOpen(state),
    isSnippetCreationOpen: selectIsSnippetCreationOpen(state),
    isIconPickerOpen: selectIsIconPickerOpen(state),
    isIconCreationOpen: selectIsIconCreationOpen(state),
  }
}

const mapDispatchToProps = {
  closeIconCreation,
  openSnippetCreation,
  closeSnippetInfo,
  clearExpertOpinionSelection,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Snippets)



// WEBPACK FOOTER //
// ./src/components/Snippets/index.js